import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCalendarPlayers } from 'data/calendar/players/actions';
import styles from './leaderboard.css';


/**
 *
 * @param contentColor
 * @param fontFamilyH2
 * @returns {JSX.Element}
 * @constructor
 */

const Leaderboard = React.memo(( { contentColor, fontFamilyH2 } ) => {

    const { calendarPlayers, calendar: { id }, localization: { content }, calendar: { settings, settings: { appearance } } } = useSelector( ( state ) => state );

    const dispatch = new useDispatch();

    useEffect( () => {
        dispatch( getCalendarPlayers( id ) );
    }, [] );


    return (
        <div className={ styles.wrapper } style={ {
            ...appearance.font_style,
            color: appearance.inner_background ? '': contentColor.dark,
            backgroundColor: appearance.inner_background ? appearance.inner_background : 'rgba(0, 0, 0, .5)'
        } }>
            <h3 style={ fontFamilyH2 } className={ styles.title }>{ `${ content.calendar.top } 10` }</h3>
            { !settings.show_leaderboard_message ?
                <div className={ styles.playersTable }>
                    <div className={ styles.headerTable } style={ { borderBottomColor: contentColor.dark } }>
                        <div>{ content.quiz.players.hash }</div>
                        <div>{ content.quiz.players.name }</div>
                        { Boolean( settings && settings.show_points ) &&
                        <div className={ styles.textCenter }>
                            { content.quiz.players.points }
                        </div>
                        }
                    </div>
                    <div className={ styles.bodyTableBox }>
                        { calendarPlayers && Object.values( calendarPlayers ).map( ( el, index ) => {
                            return (
                                <div key={ index } className={ styles.bodyTable }>
                                    <p>{ index + 1 }</p>
                                    <p className={ styles.tableName }>{ el.name }</p>
                                    { Boolean( settings && settings.show_points ) &&
                                    <p className={ styles.textCenter }>{ el.points }</p>
                                    }
                                </div>
                            );
                        } ) }
                    </div>
                </div> :
                <div>
                    <p style={ { marginTop: '3rem' } }>{ content.quiz.players.message_hide_leaderbords_table }</p>
                </div>
            }

        </div>
    );
});

export default Leaderboard;